<template>
  <main>
    <div class="row col-12">
      <p class="text-h6 text-brand-5 -text-weight-medium">{{ titulo }}</p>
    </div>
    <section class="row items-center text-brand-5 -text-weight-bold">
      <div class="row items-center">
        <div class="container">
          <label class="btn-adicionar" for="arquivo"> Selecionar Arquivo</label>
          <div class="text-brand-5 text-weight-bold text">
            {{ file ? file.name : "Nenhum arquivo escolhido" }}
          </div>
          <input
            id="arquivo"
            type="file"
            @change="onFileSelected"
            @click="resetValue()"
          />
          <span class="icon">
            <img src="../../../assets/file_upload_white.svg" alt="" />
          </span>
        </div>

        <div class="row q-pl-sm" style="margin-top: 2px">
          <q-btn
            color="positive"
            label="Enviar"
            no-caps
            icon="check_circle_outline"
            @click="enviarPlanilha(false)"
          />
          <q-btn
            v-if="deletar"
            class="q-ml-sm"
            color="negative"
            label="Deletar Ferramentas"
            no-caps
            icon="check_circle_outline"
            @click="enviarPlanilha(true)"
          />
        </div>
      </div>
    </section>
  </main>
</template>

<script>
import { ref } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
export default {
  props: ["titulo", "template", "deletar"],
  setup(props) {
    const file = ref(null);

    const store = useStore();
    const $q = useQuasar();

    let onFileSelected = async (e) => {
      if (e.target.files[0].length === 0) {
        return;
      }
      file.value = e.target.files[0];
    };

    const enviarPlanilha = async (value) => {
      if (file.value == null || file.value == "null") {
        $q.notify({
          message: "Selecione alguma planilha",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      } else if (
        file.value.type.split("/")[1] != "pdf" &&
        file.value.type.split("/")[0] != "image" &&
        file.value.name.split(".")[1] != "xlsx"
      ) {
        $q.notify({
          message: "Tipo de arquivo, não aceito",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }

      try {
        var reader = new FileReader();

        reader.readAsDataURL(file.value);
        reader.onload = async function () {
          try {
            await store.dispatch("fer/uploadPlanilha", {
              unidade: store.state.org.unidadeData.id,
              mapeamento: value ? "ferramenta-delete" : props.template,
              planilha: reader.result,
              repetir_patrimonio: 1,
            });

            $q.notify({
              message: "Arquivo enviado!",
              color: "positive",
              actions: [
                {
                  label: "Fechar",
                  color: "white",
                  handler: () => {
                    /* ... */
                  },
                },
              ],
            });
            file.value = null;
          } catch (error) {
            $q.notify({
              message: "Erro a o enviar planilha!",
              color: "negative",
              actions: [
                {
                  label: "Fechar",
                  color: "white",
                  handler: () => {
                    /* ... */
                  },
                },
              ],
            });
            return;
          }
        };
        reader.onerror = function (error) {
          console.log("Error: ", error);
        };
      } catch (error) {
        console.log(error);
      }
    };

    const resetValue = () => {
      const input = document.getElementById("arquivo");
      input.value = null;
    };

    return {
      file,
      enviarPlanilha,
      resetValue,
      onFileSelected,
    };
  },
};
</script>

<style scoped>
input[type="file"] {
  display: none;
}
.btn-adicionar {
  display: inline-block;
  background-color: #58afc1;
  border-radius: 5px;
  color: #fff;
  cursor: pointer;
  margin: 5px 5px 0 0;
  padding: 6px 20px;
  padding-left: 40px;
}
.text {
  display: inline;
}
.container {
  position: relative;
}
.icon {
  position: absolute;
  top: 9px;
  left: 9px;
}
</style>
